function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 1,
  y: 1,
  width: 18,
  height: 18
}), React.createElement("filter", {
  x: "-41.7%",
  y: "-36.1%",
  width: "183.3%",
  height: "183.3%",
  filterUnits: "objectBoundingBox",
  id: "Checkbox_HOVER_filter"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0862745098   0 0 0 0 0.0901960784   0 0 0 0 0.101960784  0 0 0 0.2 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter2"
}), React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowSpreadOuter2",
  result: "shadowOffsetOuter2"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), React.createElement("feComposite", {
  in: "shadowBlurOuter2",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0862745098   0 0 0 0 0.0901960784   0 0 0 0 0.101960784  0 0 0 0.08 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Icon_Checkbox_HOVER",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Rectangle-Copy-11"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#Checkbox_HOVER_filter)",
  xlinkHref: "#path-1"
}), React.createElement("rect", {
  stroke: "#002F6C",
  strokeWidth: 2,
  strokeLinejoin: "square",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  x: 2,
  y: 2,
  width: 16,
  height: 16
})));

var SvgCheckboxHoverBlue = function SvgCheckboxHoverBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "checkbox-hover-blue",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckboxHoverBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkbox_hover_blue.34a87640.svg";
export { ForwardRef as ReactComponent };